<div class="login-form">
	<div class="d-flex justify-content-center h-75">
		<div class="card">
			<div class="card-header">
				<h3>MSVS</h3>
			</div>
			<div class="card-body" *ngIf="loading == true">
				<h4 class="mb-4">Loading</h4>
			</div>
			<ng-container *ngIf="loading == false">
				<div class="card-body" *ngIf="!confirmation">
					<h4 class="mb-4">No confirmation found</h4>
				</div>
				<div class="card-body" *ngIf="confirmation && confirmation.open == false">
					<h4 class="mb-4" *ngIf="confirmation.status == true">{{confirmation.typeLabel}} confirmed</h4>
					<h4 class="mb-4" *ngIf="confirmation.status == false">{{confirmation.message??'Canceled'}}</h4>
				</div>
				<div class="card-body" *ngIf="confirmation && confirmation.open == true">
					<div class="pt-3 pb-5 ps-4 pe-4">
						<h4 class="mb-4">Confirm change of {{confirmation.typeLabel}}</h4>
						<p *ngIf="confirmation.to">
							New {{confirmation.typeLabel}}: <strong>{{confirmation.to}}</strong>
						</p>

						<form [formGroup]="form" class="mb-3 text-center">
							<div class="alert alert-danger" *ngIf="confirmation.message">
								{{confirmation.message}}
							</div>

							<div class="mb-5">
								<label for="input-otp" class="form-label">One-Time password</label>
								<br>
								<nz-input-otp id="input-otp" [nzLength]="6" formControlName="otp" appAutoFocus name="otp"></nz-input-otp>
							</div>

							<div class="btn-group w-100 mt-3">
								<button class="w-75 btn btn-danger" type="submit" [disabled]="form.invalid" *ngIf="submitting == false" (click)="decline()">Decline</button>
								<button class="w-75 btn btn-primary" type="submit" [disabled]="form.invalid" *ngIf="submitting == false" (click)="accept()">Accept</button>
								<button class="w-75 btn btn-primary" type="submit" [disabled]="true" *ngIf="submitting == true">
									<i nz-icon nzType="loading" nzTheme="outline"></i>
								</button>
							</div>
						</form>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>
